const ORDER_THANKYOU_PREFIX = "eatally:order-thankyou:";

function storageKey(orderId) {
  return `${ORDER_THANKYOU_PREFIX}${orderId}`;
}

export function rememberOrderThankyou(
  orderId,
  storage = window.sessionStorage
) {
  try {
    storage.setItem(storageKey(orderId), "true");
  } catch (_) {
    // Payment must still continue when storage is unavailable or blocked.
  }
}

export function hasRememberedOrderThankyou(
  orderId,
  storage = window.sessionStorage
) {
  try {
    return storage.getItem(storageKey(orderId)) === "true";
  } catch (_) {
    return false;
  }
}

export function forgetOrderThankyou(orderId, storage = window.sessionStorage) {
  try {
    storage.removeItem(storageKey(orderId));
  } catch (_) {
    // The marker is only a UI hint, so a storage failure is non-fatal.
  }
}
